"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toSafeRecord = void 0;
const toSafeRecord = (record, errorFn) => new Proxy(record, {
    get: (target, p) => {
        if (p === "then" || p === "toJSON") {
            return target[p];
        }
        else if (!Reflect.has(target, p) || target[p] === undefined) {
            throw errorFn(p);
        }
        return target[p];
    },
});
exports.toSafeRecord = toSafeRecord;
//# sourceMappingURL=js-utils.js.map